import { FileText, LogOut, Settings, Users } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { cn } from '../lib/utils';
import { BrandLogo } from './BrandLogo';
import { Button } from './ui/Button';

const navItems = [
  { to: '/clients', label: 'Clients', icon: Users },
  { to: '/invoices', label: 'Invoices', icon: FileText },
  { to: '/settings', label: 'Settings', icon: Settings }
];

export function AppShell({ children }: { children: React.ReactNode }) {
  const { signOut } = useAuth();

  return (
    <main className="min-h-screen bg-bone text-ink">
      <header className="sticky top-0 z-30 border-b border-ink/10 bg-ivory/95 backdrop-blur">
        <div className="mx-auto flex min-h-20 w-full max-w-7xl flex-wrap items-center justify-between gap-2 px-4 py-3 sm:flex-nowrap sm:gap-3 sm:px-6">
          <NavLink to="/clients" className="order-1 p-1" aria-label="Storyly admin">
            <BrandLogo variant="mark" className="h-11" />
          </NavLink>
          <nav className="order-3 flex min-w-0 basis-full justify-center gap-1 sm:order-2 sm:flex-1 sm:basis-auto" aria-label="Admin sections">
            {navItems.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    cn(
                      'inline-flex h-10 flex-1 items-center justify-center gap-2 rounded-sm px-2 text-sm font-semibold transition hover:bg-ink/10 sm:flex-none sm:px-3',
                      isActive ? 'bg-black text-ivory' : 'text-ink/70'
                    )
                  }
                >
                  <Icon className="h-4 w-4" />
                  <span>{item.label}</span>
                </NavLink>
              );
            })}
          </nav>
          <Button className="order-2 sm:order-3" variant="ghost" onClick={() => void signOut()}>
            <LogOut className="h-4 w-4" />
            <span>Sign out</span>
          </Button>
        </div>
      </header>
      <div className="mx-auto w-full max-w-7xl px-4 py-8 sm:px-6 lg:py-10">{children}</div>
    </main>
  );
}
